module.exports = __webpack_public_path__ + "img/share.c266de00.svg";